export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      icon: 'toggle-on',
      title: 'Cancel Selected Appointments',
      cls: "bulk-cancel-appointment",
      disabled: false
    }
  ],
  "actions": [
    {
      title: "Edit Appointment",
      cls: "edit-appointment",
      icon: "pencil",
      disabled:false
    },
    {
      title:"Cancel Appointment",
      cls:"cancel-appointment",
      icon:"ban",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/appointmentForm/filter/actionOptions.js